import { render, staticRenderFns } from "./indsubindic.vue?vue&type=template&id=1d43d0e8&scoped=true&"
import script from "./indsubindic.vue?vue&type=script&lang=js&"
export * from "./indsubindic.vue?vue&type=script&lang=js&"
import style0 from "./indsubindic.vue?vue&type=style&index=0&id=1d43d0e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43d0e8",
  null
  
)

export default component.exports